<template>
  <div class="home">
    - <img alt="Vue logo" src="../assets/logo.png" />
    <HelloWorld msg="小不点的技术分享" />

    <!--  底部  -->
    <div class="footer">
      <span
        >Copyright © 2022-2024 All Rights Reserved.
        <a href="https://beian.miit.gov.cn/" target="_blank">备案号:</a>
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >京ICP备2022005571号-1</a
        >
      </span>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
    HelloWorld,
  },
};
</script>

<style scoped lang="less">
.home {
  float: center;
  padding-top: 5%;
  background-image: url("~@/assets/background.png");
  background-size: cover;
  height: 100%;
}
.footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #03131c;
  font-family: Arial;
  font-size: 14px;
  letter-spacing: 1px;
}
</style>
